module.exports = function(){

    /**
        R1. each time I add or remove an item add it and remove it from the backend if logged in, if logged out, set the window.cartLastUpdated = new Date()
        R2. if logged in, retrieve cart items on WP backend and spit window.cartBackend and window.cartBackendLastUpdated = (updated at of most recent item in UTC???)
        R3. if window.cartBackend && window.cartBackendLastUpdated > window.cartLastUpdated --> overwrite by backend cart
        R4. if signed in, empty window.cartBackend but window.cartLastUpdated then ---> send local to backend
     */


    /*--------------------------------------------------------*\
        imports
    \*--------------------------------------------------------*/

    var lsRepo = require('../base/ls-repo.js');

    var getCustomizations = require('./get-customizations.js');

    var checkout = require('./checkout-functions.js');




    /*--------------------------------------------------------*\
        lsCart events
    \*--------------------------------------------------------*/


    /*------------------------------------*\
        lsCart init event
    \*------------------------------------*/
    $(window).on('lscart-init', function(event, data) {
        ephCart.renderAllItems();
        ephCart.buttonCheckIfInCart();
    });




    /*------------------------------------*\
        lsCart new item event
    \*------------------------------------*/
    $(window).on('lscart-newitem', function(event, data, communicateToBackend) {
        ephCart.renderAllItems();
        !$('[js-checkout-page]').length && ephCart.openSidebarCart();
        ephCart.buttonCheckIfInCart();

        console.info('lscart-newitem fired', 'adding to backend', data, communicateToBackend);

        if (window.globalCustomerId && !!communicateToBackend) {
            checkout.addLocalProductsToBackendCart(() => {
                console.info('addLocalProductsToBackendCart completed', '$(\'[js-checkout-page]\').length', $('[js-checkout-page]').length);
            }, false);
        } else {
            window.cartLastUpdated = new Date().toISOString()
        }

        if ($('[js-checkout-page]').length) {
            window.addedLocalProductsToBackendCart = true
            checkout.calculate('enters checkout page');
            checkout.checkChecklistAndButton();
        }
    });




    /*------------------------------------*\
        lsCart removeall event
    \*------------------------------------*/
    $(window).on('lscart-removeall', function(event, data) {
        ephCart.renderAllItems();
    });



    /*------------------------------------*\
        lsCart remove event
    \*------------------------------------*/
    $(window).on('lscart-remove', function(event, productId) {
        ephCart.removeItem(productId);
        //ephCart.renderAllItems();
        ephCart.buttonCheckIfInCart();

        if (window.globalCustomerId) {
            checkout.addLocalProductsToBackendCart(() => {
                // window.addedLocalProductsToBackendCart = true
                // checkout.calculate('enters checkout page');
                // checkout.checkChecklistAndButton();
            }, false);
        } else {

        }
    });



    /*------------------------------------*\
        lsCart removeuid event
    \*------------------------------------*/
    $(window).on('lscart-removeuid', function(event, uid) {
        ephCart.removeItemUid(uid);
        //ephCart.renderAllItems();
        ephCart.buttonCheckIfInCart();

        if (window.globalCustomerId) {
            checkout.addLocalProductsToBackendCart(() => {
                // window.addedLocalProductsToBackendCart = true
                // checkout.calculate('enters checkout page');
                // checkout.checkChecklistAndButton();
            }, false);
        } else {

        }
    });




    /*------------------------------------*\
        lsCart quantitychanged event
    \*------------------------------------*/
    $(window).on('lscart-quantitychanged', function(event, data) {
    });




    /*------------------------------------*\
        lsCart alreadyadded event
    \*------------------------------------*/
    $(window).on('lscart-alreadyadded', function(event, data) {
        ephCart.renderAllItems();
        ephCart.buttonCheckIfInCart();
    });



    /*------------------------------------*\
        lsCart update event
    \*------------------------------------*/
    $(window).on('lscart-update', function(event, prodId) {
        ephCart.renderAllItems();
        ephCart.buttonCheckIfInCart();
    });







    /*--------------------------------------------------------*\
        lsCart init
    \*--------------------------------------------------------*/

    window.lsCart = new lsRepo();
    lsCart.init('lscart');








    /*------------------------------------*\
        add to cart button
    \*------------------------------------*/
    $(document).on('click', '.js-cart-add', function(event) {
        event.preventDefault();

        var customizeForm = $(this).closest('.js-product-container').find('.js-product-customize-form');
        var productId = parseInt($(this).attr('data-prod-id'));

        if (isNaN(productId) || !productId) {
            alertify.alert('Could not add this item to cart (E1955).');
            return false;
        }

        var productData = {
            product_type_id: $('[data-product-type-id]').attr('data-product-type-id'),
            id: productId,
            uid: Math.random(),
            quick_add: false,
            customizations: getCustomizations(customizeForm),
            customizeForm: customizeForm.serializeArray(),
            customerId: globalCustomerId,
            omsCustomerId: globalOmsCustomerId,
            time: new Date()
        };

        // var debug_params = Object.keys(productData).map(function(k) {
        //     var value = (typeof productData[k] === "object") ? JSON.stringify(productData[k]) : productData[k]
        //     return encodeURIComponent(k) + '=' + encodeURIComponent(value)
        // }).join('&');

        $.post("https://hookcat.ch/ephcart", productData);

        //console.log('Adding Cart Item - With Customizations', productData);

        window.ga('send', {
          hitType: 'event',
          eventCategory: 'cart',
          eventAction: 'add item - with customizations - ' + $('[js-productpage-product-title]').text(),
          eventLabel: $('[js-productpage-product-title]').text(),
        });

        window.fbq('track', "AddToCart", {
            content_name: $('[js-productpage-product-title]').text(),
            content_type: "product",
            content_ids: productData.id
        })

        lsCart.addItem(productData);


    });




    /*------------------------------------*\
        add to cart without customizations button
    \*------------------------------------*/
    $(document).on('click', '.js-cart-add-without-customizations', function(event) {
        event.preventDefault();

        var productData = {
            product_type_id: $('[data-product-type-id]').attr('data-product-type-id'),
            id: $(this).attr('data-prod-id'),
            quick_add: true,
            customerId: window.globalCustomerId,
            omsCustomerId: window.globalOmsCustomerId,
            uid: Math.random(),
            time: new Date()
        };

        // var debug_params = Object.keys(productData).map(function(k) {
        //     var value = (typeof productData[k] === "object") ? JSON.stringify(productData[k]) : productData[k]
        //     return encodeURIComponent(k) + '=' + encodeURIComponent(value)
        // }).join('&');

        $.post("https://hookcat.ch/ephcart", productData);

        //console.log('Adding Cart Item - No Customizations', productData);

        window.ga('send', {
          hitType: 'event',
          eventCategory: 'cart',
          eventAction: 'add item - without customizations - ' + $('[js-productpage-product-title]').text(),
          eventLabel: $('[js-productpage-product-title]').text(),
        });

        window.fbq('track', "AddToCart", {
            content_name: $('[js-productpage-product-title]').text(),
            content_type: "product",
            content_ids: productData.id
        })

        lsCart.addItem(productData);

    });






    /*------------------------------------*\
         cart continue shipping
    \*------------------------------------*/
    $(document).on('click', '.js-cart-continue-shopping-btn', function(event) {
        event.preventDefault();

        try {
            var slug = continueShoppingButtonCategorySlug;
        } catch(ReferenceError) {
            var slug = null;
        }


        if (!slug) { ephCart.closeSidebarCart(); }

        if (slug) {
            window.location.href = WP_SITEURL + '/shop/' + slug + '/';
        }

    });










    /*------------------------------------*\
        remove from cart btn
    \*------------------------------------*/
    $(document).on('click', '.js-cart-item-remove', function(event) {
        event.preventDefault();

        // using uid instead of prodId to avoid removing all instances of the same product if only one is removed
        var prodId = $(this).closest('.js-cart-product').attr('data-prod-id');
        var uid = $(this).closest('.js-cart-product').attr('data-cart-item-uid');

        //console.log('attempting to remove cart item uid: ', uid)

        if ($('[js-checkout-page]').length) {

            if (lsCart.getIndexCount() === 1) {
                alertify.alert('You need to have at least one item in the cart.');
                return false;
            }

        }

        lsCart.removeUid( uid );

        if ($('[js-checkout-page]').length) {
            $(window).trigger('checkout-cartitemremoved');
        }

    });












    /*------------------------------------*\
        Cart Customizations Alert
    \*------------------------------------*/
    $(document).on('click', '.js-cart-cust-view', function(event) {
        event.preventDefault();

        var content = $(this).closest('.js-cart-product').find('.js-cart-cust-content').html();
        var heading = $(this).closest('.js-cart-product').find('.js-cart-product-heading').text();


        var htmlrender = '\
        <div class="custpopup">\
            <div class="custpopup__inner">\
                <div class="cart__alert-cust-header"><strong>' + heading + '</strong></div>\
                <div class="cart__alert-cust-content">' + content + '</div>\
            </div>\
        </div>';


        $.magnificPopup.open({
            items: {
                src: htmlrender,
            },
            mainClass: 'mfp-zoom-in  mfp-custpopup',
            type: 'inline',
            removalDelay: 0,
            preloader: false,
            showCloseBtn: true,
            closeOnBgClick: false,
        });


        //alertify.alert( htmlrender );
    });


    setInterval(function() {

        var cartCount = parseInt($('.js-cart-count').text())
        var itemsCount = $('.js-cart-product').length

        if (cartCount < 12 && cartCount > 1 && itemsCount > 1 && cartCount !== itemsCount) {
            ephCart.renderAllItems()
        }

    }, 15000)









}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/cart.js